"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsBrowser = void 0;
var _browser = require("../utils/browser");
var _useHasMounted = require("./useHasMounted");
/** Checks to see that there is a window and the DOM has mounted */
const useIsBrowser = () => {
  const hasMounted = (0, _useHasMounted.useHasMounted)();
  return (0, _browser.isBrowser)() && hasMounted;
};
exports.useIsBrowser = useIsBrowser;